import react from 'react';
import WenAestheticImg from '../Images/Website aesthetic image.png';
import '../cssfiles/About.css';
import { TypeAnimation } from 'react-type-animation';
import GameOne from '../Images/Turret monitor Game icon (new).png';
import GameTwo from '../Images/Bad UI icon new 2.png';
// Screen shots
import scnStOne from '../Images/Dream your phone number 1.png';
import scnStTwo from '../Images/Dream your phone number 112.png';
import scnStThree from '../Images/Dream your phone number.png';
// Bad Ui Screen shot
import TscnStOne from '../Images/Destruction.png';
import TscnStTwo from '../Images/Jungle image.png';
import TscnStThree from '../Images/Visual written seven.png';



function About() {
    return (
       <>
        <TypeAnimation className='AnimText'
      sequence={[
        // Same substring at the start will only be typed out once, initially
        'Hi, I am Samim Ahmed',
        1000, // wait 1s before replacing "Mice" with "Hamsters"
        'Hi,  I am game developer',
        1000,
        'Hi, I am web developer',
        1000
      ]}

      wrapper="span" 
      speed={50}
      repeat={Infinity}
    />
       <p className='skills' >Indie Game Developer | Unity | C# | Web Developer</p>
       <img className='frontImg' src={WenAestheticImg} alt='Website aesthetic image' />
        <div className='fronInformation'>

         <div className='SkillShow'>
          <p className='SkillTxt'>Skills</p> 

          <div >
             <p>web development</p>
             <progress id='webDevelopment' value="80" max="100"> </progress>
           </div>

        <div>
          <p>Game development</p>
        <progress id='GameDevelopment' value="85" max="100"></progress>
        </div>
       
          <div>
          <p>Unity</p>
          <progress id='Unity' value="90" max="100"></progress>
          </div>

          <div>
          <p>Marketing</p>
          <progress id='Marketing' value="60" max="100"></progress>
          </div>

          <div>
          <p>2d art</p>
          <progress id='TwodArt' value="70" max="100"></progress>
          </div>

          <div>
          <p>Communication</p>
          <progress id='Communication' value="85" max="100"></progress>
          </div>

         </div>

          <p className='projecttxt'>Projects</p>

           <div className='ProjectOne'>
            <img src={GameOne} />
            <p className='GameOneName'> Turret Monitor </p>
            <p className='AboutGame'>Turret Monitor is a 2D tower defense game where you must protect your turret at all costs. Upgrade its power, health, rate of fire, and damage to survive relentless attacks from unknown creatures in an abandoned world.

Developed solo over eight months, this game was a journey of challenges and learning. Despite obstacles, I pushed through to bring my vision to life. Now, I can’t wait for players to experience the thrill of survival and strategy! 🎮🔥</p>
                <div  className="gameScShort">
                   <img src={TscnStOne} />
                   <img src={TscnStTwo} />
                   <img src={TscnStThree} />
                </div>
            <a className='DownloadAGmeOne' href='https://play.google.com/store/apps/details?id=com.MukstarGame.TurretMonitor&pcampaignid=web_share'>Download</a>
           </div>


           <div className='ProjectOne'>
            <img src={GameTwo} />
            <p className='GameOneName'> Bad UI </p>
            <p className='AboutGame'>

Bad UI is design done in the worst possible way — confusing buttons, weird layouts, impossible inputs, broken logic, and interactions that make you question reality. It’s the art of making simple tasks feel hilariously painful, and that chaos is exactly what makes it fun to play with in a game.</p>
           <div  className="gameScShort">
                   <img src={scnStOne} />
                   <img src={scnStTwo} />
                   <img src={scnStThree} />
                </div>
            <a className='DownloadAGmeOne' href='https://play.google.com/store/apps/details?id=com.MukstarGame.BadUi&pcampaignid=web_share'>Download</a>
           </div>
        </div>
  
       </>
    ) 
} 

export default About;